module.exports = __webpack_public_path__ + "img/img_cx6.415fdfd5.jpg";